var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.wjlEditorLoading,
          expression: "wjlEditorLoading"
        }
      ],
      staticClass: "wjlEditor ql-editor"
    },
    [
      _c("div", {
        ref: "wjlEditor" + _vm.onlyKey,
        class: { showBorder: _vm.showBorder },
        staticStyle: {
          background: "#ffffff",
          display: "flex",
          "flex-direction": "column"
        },
        attrs: { id: "wjlEditor" + _vm.onlyKey }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c63c9c2e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c63c9c2e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wjlEditor/index.vue
// module id = null
// module chunks = 